import styled from "styled-components";


export const AccordionContainerStyled = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 1rem 0.6rem;
    background: ${({theme})=> theme === "dark" ? 'rgba(0, 153, 144, 0.2)' : '#5fbec5'};
    color: #fff;
    cursor: pointer;

`

export const AccordionContentStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    .dataObject{
        display: flex;
        justify-content: space-between;
        gap: 0.25rem;
        background: rgba(0, 153, 144, 0.1);
        padding: 1rem;
        border-radius: 1.25rem;
        
        .info{
            display: flex;
            gap: 0.5rem;
            .nameTag{
                width: 30px;
                height: 30px;
                background: ${({theme})=> theme === "dark" ? 'rgba(0, 153, 144)' : '#5fbec5'};
                border-radius: 50%;
                color: #fff;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }
            
        }
        .connect{
            color: ${({theme})=> theme === "dark" ? 'rgba(0, 153, 144)' : '#5fbec5'};
            border: 1px solid ${({theme})=> theme === "dark" ? 'rgba(0, 153, 144)' : '#5fbec5'};
            border-radius: 1.25rem;
            padding: 0rem 0.7rem;
            background: none;
            cursor: pointer;
        }
    }
`

export const AccordionModalStyled = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    backdrop-filter: blur(6px);
    background: rgba(0, 0, 0, 0.4);
    z-index: ${({zIndex}) => zIndex || '1000000'};
    overflow-y: auto;

    @media (max-width: 768px) {
        align-items: flex-start;
        padding: 5vh 1rem;
        box-sizing: border-box;
    }

    .modal-content {
        background: #fff;
        color: #111;
        padding: clamp(1rem, 3vw, 2rem);
        border-radius: 12px;
        /* Responsive modal widths: 100% on mobile, 70% on medium screens, 50% on desktop */
        width: 100%;
        max-width: 100%;
        @media (min-width: 768px) and (max-width: 1023.98px) {
            width: 70%;
            max-width: 70%;
        }
        @media (min-width: 1024px) {
            width: ${({width})=> width || '50%'};
            max-width: ${({width})=> width || '50%'};
        }
        height: ${({height})=> height || 'fit-content'};
        /* keep the modal box within the viewport; actual scrolling should happen in .modal-body */
        max-height: min(90vh, calc(100dvh - 108px - env(safe-area-inset-top) - env(safe-area-inset-bottom)));
        margin: auto;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 0.5rem;
        h1{
            color: #000;
            font-size: 1.1rem;
            border: none;
            padding: 0;
            margin: 0;
        }
        h2, h3, h4, h5, h6 { color: inherit; }
        p, span, li, div { color: inherit; }
    }

    /* The scrollable area inside the modal. Keeping scrolling here prevents .cancel from moving. */
    .modal-body {
        width: 100%;
        overflow-y: auto;
        max-height: min(90vh, calc(100dvh - 108px - env(safe-area-inset-top) - env(safe-area-inset-bottom)));
    }

    .cancel {
        position: absolute;
        display: flex;
        font-weight: 900;
        font-size: 1.7rem;
        justify-content: space-between;
        color: #5fbec5;
        top: 10px;
        right: 10px;
        cursor: pointer;
    }
`